var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{staticClass:"appup-image",attrs:{"id":_vm.id,"src":_vm.src,"alt":_vm.alt,"height":_vm.height,"width":_vm.width,"left":_vm.imgAlignmentLeft,"right":_vm.imgAlignmentRight,"center":_vm.imgAlignmentCenter,"rounded":_vm.imgType,"thumbnail":_vm.thumbnail,"fluidGrow":_vm.imgAutoResize},on:{"click":_vm.onImageClick}})}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/image/image.vue